const illustrationUrls = {
  challenge: "/assets/valchain/challenge.png",
  commerce: "/assets/valchain/commerce.png",
  finance: "/assets/valchain/finance.png",
  governance: "/assets/valchain/governance.png",
  traceability: "/assets/valchain/traceability.png",
  cooperatives: "/assets/valchain/cooperatives.png",
};

const PremiumIllustration = ({ src, alt, testId }) => (
  <div data-testid={testId} className="premium-illustration-card">
    <img data-testid={`${testId}-image`} src={src} alt={alt} loading="lazy" />
  </div>
);

export const ChallengeIllustration = () => (
  <PremiumIllustration testId="challenge-premium-illustration" src={illustrationUrls.challenge} alt="Premium illustration of fragmented agricultural stakeholders becoming connected" />
);

export const MarketplaceIllustration = () => (
  <PremiumIllustration testId="marketplace-premium-illustration" src={illustrationUrls.commerce} alt="Premium illustration of agricultural marketplace and commerce flows" />
);

export const FinanceFlowIllustration = () => (
  <PremiumIllustration testId="finance-premium-illustration" src={illustrationUrls.finance} alt="Premium illustration of agriculture value chain financing events" />
);

export const GovernanceIllustration = () => (
  <PremiumIllustration testId="governance-premium-illustration" src={illustrationUrls.governance} alt="Premium illustration of governance, traceability, and audit records" />
);

export const TraceabilityIllustration = () => (
  <PremiumIllustration testId="traceability-premium-illustration" src={illustrationUrls.traceability} alt="Premium illustration of traceability and transparent agricultural records" />
);

export const CooperativesIllustration = () => (
  <PremiumIllustration testId="cooperatives-premium-illustration" src={illustrationUrls.cooperatives} alt="Premium illustration of FPOs and cooperatives strengthening collective agriculture" />
);